
import axios from 'axios'
import $qs from 'qs'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {
components: { InlineLoading },
data() {
return {
uploading: false,
size: 1,
imgSrc: ''
}
},
methods: {
_getUploadFile(e) { // 获取选择文件资源
const files = e.target.files
const input = e.target
if(files && files[0]) {
const file = files[0];
if (file.size > 1024 * 1024 * this.size) {
this.$vux.toast.show({ text: `${this.$t('upload').errorTips} ${this.size} ${this.$t('upload').imgSize}`, type: 'cancel' })
input.value = ''
} else {
this.uploading = true
const formData = new FormData()
formData.append('file', file)
formData.append('UUID', this.$store.state.UUID)
this._upload(formData)
}
}
},
_upload(params) { // 上传文件
axios.interceptors.request.use(config => {

if (config.method === 'post') {
config.data = $qs.stringify(config.data)
}
return config
}, error => {
Promise.reject(error)
})
let ax = axios.create()
let config = {
headers: {
"Content-Type": "multipart/form-data"
}
}
ax.post('/api/uploadFile', params, config).then(result => {
if (result.data.code === 200) {
this.$emit('backFile', result.data.data)
this.imgSrc = this.$store.state.linkList.staticDomain + result.data.data
} else {
this.$vux.toast.show({ text: result.data.msg, type: 'cancel' })
}
let timer = setTimeout(() => {
this.uploading = false
clearTimeout(timer)
},666)
}).catch(err => {
this.uploading = false
console.log(err)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build821/views/components/p-certificate/index.vue